import { render, staticRenderFns } from "./BoxOffice.vue?vue&type=template&id=52b5e4ec&scoped=true&"
import script from "./BoxOffice.vue?vue&type=script&lang=js&"
export * from "./BoxOffice.vue?vue&type=script&lang=js&"
import style0 from "./BoxOffice.vue?vue&type=style&index=0&id=52b5e4ec&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b5e4ec",
  null
  
)

export default component.exports